import forEach from 'lodash/forEach'
import extend from 'lodash/extend'
import isArray from 'lodash/isArray'
import filter from 'lodash/filter'
import each from 'lodash/each'
import set from 'lodash/set'
import merge from 'lodash/merge'
import isFunction from 'lodash/isFunction'
import has from 'lodash/has'
import get from 'lodash/get'
import clone from 'lodash/clone'
import startsWith from 'lodash/startsWith'
import isString from 'lodash/isString'
import isPlainObject from 'lodash/isPlainObject'
import split from 'lodash/split'
import isNaN from 'lodash/isNaN'
import once from 'lodash/once'
import isBoolean from 'lodash/isBoolean'
import isNumber from 'lodash/isNumber'
import isEmpty from 'lodash/isEmpty'
import keys from 'lodash/keys'
import map from 'lodash/map'
import find from 'lodash/find'
import reject from 'lodash/reject'
import concat from 'lodash/concat'
import pullAt from 'lodash/pullAt'
import indexOf from 'lodash/indexOf'
import omit from 'lodash/omit'
import flatten from 'lodash/flatten'
import values from 'lodash/values'
import pick from 'lodash/pick'
import isNil from 'lodash/isNil'
import findIndex from 'lodash/findIndex'
import remove from 'lodash/remove'
import sortBy from 'lodash/sortBy'
import replace from 'lodash/replace'
import take from 'lodash/take'
import join from 'lodash/join'
import first from 'lodash/first'
import endsWith from 'lodash/endsWith'
import last from 'lodash/last'
import toPairs from 'lodash/toPairs'
import groupBy from 'lodash/groupBy'
import flattenDeep from 'lodash/flattenDeep'
import toLower from 'lodash/toLower'
import uniq from 'lodash/uniq'
import debounce from 'lodash/debounce'
import toUpper from 'lodash/toUpper'
import compact from 'lodash/compact'
import reverse from 'lodash/reverse'
import difference from 'lodash/difference'
import includes from 'lodash/includes'
import sum from 'lodash/sum'
import mapValues from 'lodash/mapValues'
import toArray from 'lodash/toArray'
import reduce from 'lodash/reduce'
import some from 'lodash/some'
import isEqual from 'lodash/isEqual'
import throttle from 'lodash/throttle'
import isObject from 'lodash/isObject'
import fromPairs from 'lodash/fromPairs'
import intersection from 'lodash/intersection'
import assign from 'lodash/assign'
import union from 'lodash/union'
import maxBy from 'lodash/maxBy'

const move = function (array, index, delta) {
  var newIndex = index + delta
  if (newIndex < 0 || newIndex === array.length) return // Already at the top or bottom.
  var indexes = [index, newIndex].sort() // Sort the indixes
  array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]) // Replace from lowest index, two elements, reverting the order
}

const moveUp = function (array, index) {
  move(array, index, -1)
}

const moveDown = function (array, index) {
  move(array, index, 1)
}

export const ld = {
  forEach,
  extend,
  isArray,
  filter,
  each,
  set,
  merge,
  union,
  isFunction,
  has,
  get,
  clone,
  startsWith,
  isString,
  isPlainObject,
  split,
  isNaN,
  once,
  isNumber,
  isBoolean,
  isEmpty,
  keys,
  map,
  find,
  reject,
  concat,
  pullAt,
  indexOf,
  omit,
  flatten,
  values,
  pick,
  isNil,
  findIndex,
  remove,
  sortBy,
  replace,
  take,
  join,
  first,
  endsWith,
  last,
  toPairs,
  groupBy,
  flattenDeep,
  toLower,
  uniq,
  moveUp,
  moveDown,
  move,
  debounce,
  toUpper,
  compact,
  reverse,
  difference,
  includes,
  sum,
  mapValues,
  toArray,
  reduce,
  some,
  isEqual,
  throttle,
  isObject,
  fromPairs,
  intersection,
  assign,
  maxBy
}

export default ld
